// extracted by mini-css-extract-plugin
export default {"icon_label":"IconLabel_icon_label__qfotK","icon_label__icon":"IconLabel_icon_label__icon__u9k0s","spin":"IconLabel_spin__5fIe2"};